"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled = __importStar(require("./styled"));
const MoseyLayout_1 = require("../../Shared/MoseyLayout");
const TopPageLink = ({ isOnScreen, onClick }) => {
    const [showElement, setShowElement] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (isOnScreen) {
            setShowElement(true);
        }
        else if (showElement) {
            setTimeout(() => setShowElement(false), MoseyLayout_1.THROTTLE_DELAY);
        }
    }, [isOnScreen, showElement]);
    return (react_1.default.createElement(styled.Container, { isOnScreen: isOnScreen, showElement: showElement, onClick: onClick },
        react_1.default.createElement(styled.Arrow, null)));
};
exports.default = TopPageLink;
